import './instagram_message_builder.js.coffee'
import '../instagram_message_media.js.coffee'
Namespace 'Models.Builders'

class Models.Builders.InstagramMessageMediaBuilder extends Models.Builders.InstagramMessageBuilder
  constructor: ->
    super()
    @attachments = null

  build: ->
    new Models.InstagramMessageMedia(@)
